import { FlexContainer } from '@facephi/ui-react';
import styled from 'styled-components/macro';
import { desktopStyles, mobileStyles } from '../../styles';

export const ServicesWrapper = styled(FlexContainer)`
  ${desktopStyles} {
    padding: 3rem 0;
    max-width: 53rem;
  }

  > form {
    width: 100%;
    ${desktopStyles} {
      padding: 0 4.4rem;
    }
    > section {
      width: 100%;
    }

    > button {
      ${mobileStyles} {
        margin-top: auto;
      }
    }
  }
`;
